<template>
    <v-row align-md="center">
        <v-col cols="12" md="auto" class="mb-10 mb-md-0">
            <v-badge floating dot>
                <h4 class="tit--sm line-height-1">채용 리스트</h4>
            </v-badge>
        </v-col>
        <v-spacer />
        <v-col cols="12" md="auto">
            <v-row justify="end" justify-md="start" align="center">
                <v-col cols="auto" class="line-end"> <v-select v-model="query.sort" :items="sorts" item-text="text" item-value="value" :menuProps="{ attach: `.recruitment-list-filter-${className}` }" append-icon="icon-filter" outlined hide-details class="mw-140px mw-lg-160px v-input--small v-select--filter" :class="`recruitment-list-filter-${className}`" v-bind="attrs_input" @change="search" /> </v-col>
                <v-col cols="auto">
                    <v-btn-toggle v-model="query.state" borderless class="ml-n4 flex-wrap flex-sm-nowrap justify-end" style="overflow: hidden" @change="search">
                        <v-btn :to="$route.query.state ? { query: { ...$route.query, state: [] } } : { query: $route.query }" exact text color="grey-6" height="auto" @click.prevent.stop.capture="((query.state = null) || true) && search()">
                            <v-simple-checkbox :value="!query.state" color="primary" />
                            <span class="font-weight-regular">전체보기</span>
                        </v-btn>
                        <v-btn v-for="{ text, value } in states" :key="text" v-bind="{ value }" exact text color="grey-6" height="auto">
                            <v-simple-checkbox :value="value == query.state" color="primary" @click.stop="toggle(value)" />
                            <span class="font-weight-regular">{{ text }}</span>
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { attrs_input, RECRUITMENT_STATES } from "@/assets/variables";

const sorts = [
    { text: "생성일 ↓", value: "createdAt_desc" },
    { text: "생성일 ↑", value: "createdAt_asc" },
    { text: "접수시작일 ↓", value: "application.startsAt_desc" },
    { text: "접수시작일 ↑", value: "application.startsAt_asc" },
    { text: "접수종료일 ↓", value: "application.endsAt_desc" },
    { text: "접수종료일 ↑", value: "application.endsAt_asc" },
];
const states = Object.values(RECRUITMENT_STATES);

const initQuery = () => ({
    sort: sorts[0].value,
    state: null,
});

export default {
    props: {
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),

        sorts,
        states,
        attrs_input,

        className: Math.random().toString().slice(2),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = {
                sort: this.$route.query?.sort || sorts[0].value,
                state: this.$route.query?.state || null,
            };
        },
        toggle(value) {
            let isSame = this.query.state == value;
            this.query.state = isSame ? null : value;
            this.$nextTick(this.search);
        },
        search() {
            let { ...query } = this.query;

            if (!query.sort || query.sort == sorts[0].value) delete query.sort;
            if (!query.state) delete query.state;

            delete query.page;

            this.$router.push({ query });
        },
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .line-end {
        position: relative;
        &::after {
            content: "";
            display: block;
            position: absolute;
            width: 1px;
            height: var(--input-small-height);
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            background-color: #ccc;
        }
    }
}
@media (min-width: 1200px) {
}
</style>
